import { Modal } from '@fasstech/middle-design-system';
import PropTypes from 'prop-types';
import beclmHelpImage from '../../../../../public/images/beclm_help.png';

/**
 * BeCLM modal
 */
const BeclmBlockModal = ({ isDisplayed, onClose, getMiddleText, textKey }) => (
  <Modal isDisplayed={isDisplayed} button1Label={'OK'} onClose={onClose} onClick1={onClose}>
    <div className={'flex flex-col items-center gap-4 text-center'}>
      <img src={beclmHelpImage} alt={''} className={'w-24'} />
      <p dangerouslySetInnerHTML={{ __html: textKey ? getMiddleText(textKey) : '' }} />
    </div>
  </Modal>
);

BeclmBlockModal.propTypes = {
  isDisplayed: PropTypes.bool,
  onClose: PropTypes.func,
  getMiddleText: PropTypes.func,
  textKey: PropTypes.string
};

export default BeclmBlockModal;
